import * as React from "react";

import { Icon, Label } from "@fluentui/react";

import { AppContext } from "@1js/acui-context";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";
import { AppTooltipHost } from "@1js/acui-tooltip";

import {
  getAppLabelStatusBaseIconStyles,
  getAppLabelStatusBaseStyles,
} from "../AppLabelStatusBase";
import { AppLabelProps } from "./AppLabel.Props";

export class AppLabel extends React.PureComponent<AppLabelProps, {}> {
  private labelRef = React.createRef<HTMLDivElement>();
  private tooltipHost: AppTooltipHost | undefined;

  // This allows us to access AppContext directly from this.context
  static contextType: any = AppContext;
  declare context: React.ContextType<typeof AppContext>;

  public componentDidMount() {
    // The only time the label should have a tooltip is when there is a custom tooltip defined
    if (
      this.context.setTooltipElement &&
      this.context.updateTooltipsHidden &&
      this.props.customTooltip
    ) {
      this.tooltipHost = new AppTooltipHost({
        updateTooltipsHidden: this.context.updateTooltipsHidden,
        setTooltipElement: this.context.setTooltipElement,
        refElement: this.labelRef,
        controlId: this.props.id,
        controlLabel: this.props.customTooltip,
        tooltipDirection: this.props.tooltipDirection,
        performSetOnNextFrame: !!checkExperiment(
          this.context,
          ribbonExperiments.delayRenderTooltipsIsEnabled
        ),
      });
      this.tooltipHost.registerTooltipHostActions();
    }
  }

  public componentWillUnmount() {
    if (this.tooltipHost) {
      this.tooltipHost.unregisterTooltipHostActions();
    }
  }

  public render() {
    const { label, iconProps, forId, id } = this.props;
    const classNames = getAppLabelStatusBaseStyles(this.props.styles);
    return (
      <div className={classNames.root} ref={this.labelRef}>
        {iconProps && (
          <Icon
            {...iconProps}
            styles={getAppLabelStatusBaseIconStyles(iconProps)}
          />
        )}
        <Label htmlFor={forId} id={id} className={classNames.label}>
          {label}
        </Label>
      </div>
    );
  }
}
